/**
 * Returns the user's preference for dark mode based on the operating system.
 * @returns {boolean} The user's preference for dark mode. Returns true if the user prefers
 * dark mode, false otherwise.
 */
export default () => (globalThis.matchMedia ? globalThis.matchMedia('(prefers-color-scheme: dark)').matches : false);
